import Main from './main/main';

function App() {
  return (
    <Main/>
  );
}

export default App;
